import TextInput from 'components/src/textInput/TextInput';
import Checkbox from 'components/src/checkbox';

type TextInputFormProps = {
  id: string;
  label: string;
  type: string;
  value: string;
  handleFormChange: (id: string, value: string) => void;
};

const TextInputForm = (props: TextInputFormProps) => {
  return (
    <TextInput
      key={props.id}
      label={props.label}
      id={props.id}
      type={props.type}
      value={props.value}
      onChange={(value) => {
        props.handleFormChange(props.id, value);
      }}
    />
  );
};

type CheckboxFormProps = {
  id: string;
  label: string;
  checked: boolean;
  disabled: boolean;
  handleCheckboxChange: (id: string, checked: boolean) => void;
};

const CheckboxForm = (props: CheckboxFormProps) => {
  return (
    <Checkbox
      key={props.id}
      label={props.label}
      id={props.id}
      onChange={(value) => {
        props.handleCheckboxChange(props.id, value.target.checked);
      }}
      checked={props.checked}
      disabled={props.disabled}
    />
  );
};

export { TextInputForm, CheckboxForm };
